import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { FormsModule } from '@angular/forms';

export interface SelectorDialogData<T> {
  title: string;
  description?: string;
  label: string;
  items: T[];
  displayFn: (item: T) => string;
  primaryButtonText?: string;
}

@Component({
  selector: 'app-selector-dialog',
  imports: [MatDialogModule, MatButtonModule, MatListModule, FormsModule],
  templateUrl: './selector-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./selector-dialog.component.scss'],
})
export class SelectorDialogComponent<T> {
  selectedItems: T[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: SelectorDialogData<T>,
    private dialogRef: MatDialogRef<SelectorDialogComponent<T>>
  ) {}

  onConfirm(): void {
    this.dialogRef.close(this.selectedItems);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  getDisplayText(item: T): string {
    return this.data.displayFn(item);
  }
}
